import { render } from "./Leave_Allocations.vue?vue&type=template&id=34a8d8c8"
import script from "./Leave_Allocations.vue?vue&type=script&lang=js"
export * from "./Leave_Allocations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__